var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-2"},[(_vm.folio.items.length > 0)?_c('div',_vm._l((_vm.folio.items),function(item,index){return _c('comparador-folio-item',{key:`folio-item-${index}`,attrs:{"item":item}})}),1):_c('div',[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('strong',[_vm._v("No data")])])
}]

export { render, staticRenderFns }